import {
  ChangeDetectorRef,
  Component,
  ComponentFactory,
  ComponentFactoryResolver,
  HostBinding,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {ControlContainer, FormGroup, NG_VALUE_ACCESSOR} from '@angular/forms';
import {GnFormUtils} from 'geminis-ng-core';
import {GnFormItemComponent} from '../../form/form-item/form-item.component';
import {GnFormItemConfig} from './FormItemConfig';
import {formItemTypes} from './FormItem';
import {DomSanitizer, SafeStyle} from '@angular/platform-browser';


@Component({
  selector: 'gn-json-form-item',
  templateUrl: './json-form-item.component.html',
  styleUrls: ['./json-form-item.component.css']
})
export class GnJsonFormItemComponent implements OnInit {

  private readonly form: FormGroup;

  @ViewChild(TemplateRef, {static: true, read: ViewContainerRef}) container: ViewContainerRef;
  @ViewChild(GnFormItemComponent, {static: true}) formItemComponent: GnFormItemComponent;

  @Input() config: GnFormItemConfig;

  @HostBinding('style.grid-column') get colSpan(): SafeStyle {
    return this.config.colspan ?
      this.domSanitizer.bypassSecurityTrustStyle('auto / span ' + this.config.colspan) :
      null;
  }

  @HostBinding('style.grid-row') get rowSpan(): SafeStyle {
    return this.config.colspan ?
      this.domSanitizer.bypassSecurityTrustStyle('auto / span ' + this.config.rowspan) :
      null;
  }

  get visible(): boolean {
    if (this.config.visible === undefined) {
      return true;
    } else if (typeof this.config.visible === 'string') {
      const form = this.form;
      // tslint:disable-next-line:no-eval
      return eval(this.config.visible);
    } else {
      return this.config.visible;
    }
  }

  constructor(private resolver: ComponentFactoryResolver,
              private changeDetectorRef: ChangeDetectorRef,
              private domSanitizer: DomSanitizer,
              private controlContainer: ControlContainer) {
    this.form = this.controlContainer.control as FormGroup;
  }

  ngOnInit(): void {
    const inputType = formItemTypes[this.config.type];
    if (!inputType) {
      throw new Error(`输入组件[${this.config.type}]未注册`);
    }

    const controlFactory: ComponentFactory<any> = this.resolver.resolveComponentFactory(inputType);
    const componentRef = this.container.createComponent(controlFactory);
    if (this.config.options) {
      for (const key of Object.keys(this.config.options)) {
        componentRef.instance[key] = this.config.options[key];
      }
    }

    // 能够获取到子元素的ControlValueAccessor，可以直接绑定数据操作
    if (this.config.field) {
      const formControl = GnFormUtils.ensureFormControl(this.form, this.config.field, this.config.validators);
      const accessors = componentRef.injector.get(NG_VALUE_ACCESSOR, null);
      const accessor = accessors[0];
      accessor.registerOnChange(value => {
        formControl.markAsDirty();
        formControl.setValue(value);
      });
      formControl.registerOnChange(value => {
        accessor.writeValue(value);
      });
    }
  }
}
